
import React, { Component } from "react";
import { connect } from "react-redux";
import AuthService from "../../services/AuthService";
import * as Actions from "../../reducers/actions";
import { Tabs, Spin, Icon, Button } from 'antd';
import { parse } from 'qs'
import _ from "underscore";
import {
    Redirect
} from "react-router-dom";
import { Link, } from "react-router-dom";


import Config from "../../config";
import { objSearch } from "../../utils/func";
const antIcon = <Icon type="loading" style={{ fontSize: 24 }} spin />;
const TabPane = Tabs.TabPane;

class ETab14 extends Component {
    constructor(props) {
        super(props);
        this.state = {  
            plt_bld_id: "",
            year: "",
            data: []
        };
        const query =
            this.props.location && this.props.location.search
                ? parse(this.props.location.search.substr(1))
                : {};
        setTimeout(() => {
            if (!query.plt_bld_id || !query.year ) {
                // this.setState({ isBack: true });
            } else {
                this.setState({
                    plt_bld_id: query.plt_bld_id,
                    year: query.year,
                });
            }
        }, 100);

        this.getList(query.year, query.plt_bld_id);
    }
    getList(year, plt_bld_id) {
        let token ='getPdfExport';
        return fetch(
            Config.api +
            `/api/etab-14?token=${token}&plt_bld_id=${plt_bld_id}&year=${year}`,
            {
                headers: { "Content-Type": "application/json" }
            }
        )
            .then(response => response.json())
            .then(
                data => {
                    let _data = [];
                    data.data = data.data ? data.data:[]
                    // if (data.resultCode == 20000 && ) {
                        
                        let tt = _.groupBy(data.data, "TYPE");
                    let k1 = "เนื้อหาที่ไม่สมบูรณ์ในรายการหลัก";
                        if (tt[k1]){
                            _data.push({
                              key: k1,
                              data: tt[k1].sort(
                                (a, b) =>
                                  a.TIME > b.TIME
                                    ? 1
                                          : b.TIME >
                                              a.TIME
                                    ? -1
                                    : 0
                              )
                            });
                        }else{
                            _data.push({ key: k1, data: [{ STEP: "ไม่มีข่อมูล", HEADER:""}] })
                        }

                    let k2 = "เนื้อหาที่ไม่สมบูรณ์ในรายการรอง";
                        // tt[k2] =''
                        if (tt[k2]) {
                            _data.push({
                                key: k2, data: tt[k2].sort(
                                    (a, b) =>
                                        a.TIME > b.TIME
                                            ? 1
                                            : b.TIME >
                                                a.TIME
                                                ? -1
                                                : 0
                                ) })
                        } else {
                            _data.push({ key: k2, data: [{ STEP: "ไม่มีข่อมูล", HEADER: "" }] })
                        }


                        for (let i in tt){
                            if (i !== k1 && i !== k2){
                                _data.push({
                                    key: k1,
                                    data: tt[i].sort(
                                        (a, b) =>
                                            a.TIME > b.TIME
                                                ? 1
                                                : b.TIME >
                                                    a.TIME
                                                    ? -1
                                                    : 0
                                    )
                                });
                            }
                        }
                    _data = _data.map(r => {
                        let ttt = _.groupBy(r.data, "STEP");
                        let newTemp = []
                        for (let i in ttt) {
                            newTemp.push({
                                STEP: i,
                                data: ttt[i]
                            });

                        }
                        console.log("newTemp", newTemp);

                        return { key: r.key, data: newTemp }
                    })
                            //TYPE
                        console.log("getPdfStep", _data);
                        this.setState({ data: _data });
                                                                                       
                    // console.log("getPdfStep", _data);
                });
    }

    getNumber(num) {
        try {
            return parseInt(num);
        } catch (error) {
            return 0;
        }
    }

    render() {
        let { plt_bld_id, year,data } = this.state;
        return <div style={{ padding: 30 }}>
            <table className="MyStyle2" style={{ border: "1px solid #dee2e6", padding: 10, width: 800 }}>
              {data.map((r, i) => {
                return <tr style={{ border: "1px solid #dee2e6", padding: 10 }}>
                    <td style={{ padding: 10 }}>
                      <h4 style={{ textAlign: "left" }}>{r.key} </h4>
                      <div>
                        {r.data.map(rr => {
                          return <div>
                              <h5 style={{ textAlign: "left" }}>
                                {rr.STEP}{" "}
                              </h5>
                              {
                                  rr.data.map(rrr => {
                                      return <div>
                                          <h6 style={{ textAlign: "left", marginLeft: 20 }}>{rrr.HEADER} </h6>
                                      </div>
                                  })
                              }
                            </div>;
                        })}{" "}
                      </div>
                    </td>
                  </tr>;
              })}
            </table>
          </div>;
    }
}
function mapStateToProps(state) {
    return { };
}

export default connect(mapStateToProps)(ETab14);
// export default Singin;


// WEBPACK FOOTER //
// ./src/view/main/etab14.js